import { ReactNode } from 'react'
import { NavLink } from 'react-router'

const defaultTitle = 'Oops!'
const defaultDescription =
  "Something went wrong. We're sorry for the inconvenience. Our team has been notified and is working on it"

export default function GenericErrorPage({
  title = defaultTitle,
  description = defaultDescription,
  children = null,
}: {
  title?: string
  description?: string
  children?: ReactNode
}) {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8 custom-max-w-920px m-auto">
      <div className="text-center">
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          {title}
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">{description}</p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          {children ? (
            children
          ) : (
            <>
              <NavLink
                to="/"
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Go back home
              </NavLink>
              <a
                href="mailto:support@speechagenda.com?subject=Error%20Report&amp;body=Please%20describe%20your%20issue%20here."
                className="text-sm font-semibold text-gray-900">
                Contact support <span aria-hidden="true">→</span>
              </a>
            </>
          )}
        </div>
      </div>
    </main>
  )
}
